<script setup lang="ts">
defineOptions({
	name: 'ChangesSection',
})

const { t: $t } = useI18n()
</script>

<template>
	<section class="space-y-7">
		<div class="flex items-center gap-3.5">
			<UIcon
				name="i-ic:baseline-sync"
				class="size-7 text-[#ED8B00]"
			/>
			<h2 class="text-xl sm:text-2xl font-medium text-gray-900 tracking-tight">
				{{ $t('Updates and changes to the Cookie Policy') }}
			</h2>
		</div>
		<div class="space-y-5 text-base sm:text-[18px] text-[#364153] tracking-[-0.199px] leading-7">
			<p>
				{{
					$t(
						'Gaveta Decimal may amend this Cookie Policy in response to new legal requirements or to implement improvements, notifying users of significant changes via an informational notice within our Platform',
					)
				}}.
			</p>
			<p class="text-right italic pt-10 text-base">{{ $t('Date of last update: 18 November 2025') }}</p>
		</div>
	</section>
</template>
